import { Code as OriginalCode } from "@tiptap/extension-code";

export const Code = OriginalCode.extend({
  addOptions() {
    const parentOptions = this.parent?.();
    return {
      ...parentOptions,
      HTMLAttributes: {
        ...parentOptions?.HTMLAttributes,
        class: "font-normal text-code-block rounded-6 px-1.5 py-0.5 bg-gray-100 dark:bg-gray-900",
      },
    };
  },
});
